import { render } from "./CategroyModal.vue?vue&type=template&id=5641b464&scoped=true"
import script from "./CategroyModal.vue?vue&type=script&lang=js"
export * from "./CategroyModal.vue?vue&type=script&lang=js"

import "./CategroyModal.vue?vue&type=style&index=0&id=5641b464&lang=scss&scoped=true"
import "./CategroyModal.vue?vue&type=style&index=1&id=5641b464&lang=scss"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5641b464"]])

export default __exports__